import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { compose, lifecycle, setDisplayName, withState } from 'recompose';
import { bindActionCreators } from 'redux';
import { usersAction } from '@/actions';
import { getShopDashboardLink } from '@/apis';
import { paths } from '@/config';
import notify from '@/migration/notification';

const mapStateToProps = (state) => ({
  users: state.users.toJS(),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...usersAction, push }, dispatch);

const notifyError = (message) => notify(message, 'error', undefined, 5);

const enhance = compose(
  setDisplayName('StripeDashboardRedirect'),
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'isLoadingUpdater', true),
  lifecycle({
    async componentDidMount() {
      const { getMe, push, isLoadingUpdater } = this.props;

      // 別タブで直接開かれるため、このページで認証状態を確かめる。
      try {
        await getMe();
      } catch (error) {
        push(paths.before.signin);
        notifyError('セッションが切れました。再度、ログインを行なってください');
        isLoadingUpdater(false);
        return;
      }

      const {
        users: { mydata },
      } = this.props;

      try {
        const result = await getShopDashboardLink(mydata.id);

        if (result instanceof Error || !result.dashboard_url) {
          throw new Error('failed to get dashboard url');
        }
        window.location.replace(result.dashboard_url);
        return;
      } catch (error) {
        push(paths.mypage.bank_account);
        notifyError(
          '売上げ受取口座の確認画面を開けませんでした。時間をおいて再度お試しください'
        );
      }

      isLoadingUpdater(false);
    },
  })
);

export default enhance;
